import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Listing from "./pages/Listing";

function App() {
  return (
    <Router>
      <div className="App">
        <div className="header">
          <h1>Expense Tracker</h1>
        </div>

        <div className="main">
          <div className="container">
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/listingTransection" element={<Listing />} />
            </Routes>
          </div>
        </div>

        <div className="footer">&copy;2022 Jubayer Alam Khan</div>
      </div>
    </Router>
  );
}

export default App;
